import type { WizardFlowDefinition } from '@/modules/wizard/types/WizardFlowDefinition'

export const emailVerificationFlow: WizardFlowDefinition = {
  steps: [{ id: 'email_verification' }],
}
